
export enum IndeedEndDateType {
    Fixed = 1,
    Target = 2
}
